
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"opacity":".2","cx":"42.133","cy":"7","r":"6.933","fill":"#FF3636"}}),_c('path',{attrs:{"d":"M.533 7l6.19 3.574V3.426L.534 7zm5.572.619h36.028V6.381H6.105v1.238z","fill":"#FF3636"}}),_c('circle',{attrs:{"cx":"42.133","cy":"7","r":"4.003","fill":"#FF3636","stroke":"#FF3636","stroke-width":"1.238"}})])
          )
        }
      }
    